import { Button } from "@gds-react/core";
import {
  Description,
  ImageCol,
  Inner,
  SubTitle,
  TextCol,
  TextColInner,
  Title,
  Screen,
} from "./LoginPage.styles";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useEffect } from "react";
import { AuthenticationType } from "../../types/AuthenticationTypes";
import LoadingPage from "../LoadingPage";
import { useStore } from "../../store/store";
import { InteractionStatus } from "@azure/msal-browser";

const appScopes = import.meta.env.VITE_SCOPE
  ? ([...import.meta.env.VITE_SCOPE.split(" ")] as string[])
  : ([] as string[]);

export default function LoginPage() {
  const loginHint = useStore.useLoginHint();
  const setLoginHint = useStore.useSetLoginHint();
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();
  const searchParams = new URL(document.location.toString()).searchParams;
  const domainHint = searchParams.get("domainHint");

  useEffect(() => {
    if (
      !isAuthenticated &&
      loginHint !== "" &&
      inProgress === InteractionStatus.None
    ) {
      loginWithDomainHint(loginHint);
    }
  }, [loginHint, inProgress, isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      if (domainHint) {
        loginWithDomainHint(domainHint);
      }
    }
  }, [instance, inProgress, isAuthenticated]);

  const loginWithDomainHint = async (domainHint) => {
    if (domainHint) {
      setLoginHint(domainHint);
      await instance.loginRedirect({ scopes: appScopes, domainHint });
    }
  };

  return domainHint || loginHint || inProgress === InteractionStatus.Logout ? (
    <LoadingPage />
  ) : (
    <Screen>
      <Inner>
        <TextCol>
          <TextColInner>
            <SubTitle>Welcome to</SubTitle>
            <Title>Grundfos Device Manager</Title>
            <Description>Please sign in to your account</Description>
            <Button
              size="large"
              width="100%"
              onClick={() =>
                loginWithDomainHint(AuthenticationType.GrundfosInternal)
              }
            >
              <img src="/assets/images/entraid.svg" alt="entraid" />
              Grundfos Account Login (SSO)
            </Button>
          </TextColInner>
        </TextCol>
        <ImageCol src="/assets/images/login-image.png" />
      </Inner>
    </Screen>
  );
}
